@if (!onlyAutopay) {
  <form-control
    [config]="saveMethodConfig"
    [control]="form.get(saveMethodConfig.prop)"
  >
  </form-control>
}

@if (saveMethodValue || onlyAutopay) {
  <form-control
    [config]="autopayConfig"
    [control]="form.get(autopayConfig.prop)"
  >
  </form-control>
}
